export var scopeStacks = [];
